export var scopeStacks = [];
